import React, { createContext, useContext, useState } from "react";
import { useCustodyOrder } from "../../contexts/CustodyOrderContext";
import { CustodyOrder } from "../../models/CustodyOrder";
import { Dialog } from "../../design/dialog";
import CustodyOrderFormStep from "./components/CustodyOrderFormStep";

interface Context {
  openDialog: () => void;
  closeDialog: () => void;
  isOpen: boolean;
}

const CreateCustodyOrderDialogProviderContext = createContext<
  Context | undefined
>(undefined);

export const CreateCustodyOrderDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { createCustodyOrder } = useCustodyOrder();
  const [isOpen, setIsOpen] = useState(false);
  const [custodyOrderId, setCustodyOrderId] = useState<
    CustodyOrder["_id"] | null
  >(null);
  const [step, setStep] = useState<"form">("form");

  const openDialog = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  return (
    <CreateCustodyOrderDialogProviderContext.Provider
      value={{ openDialog, closeDialog, isOpen }}
    >
      <Dialog open={isOpen} onClose={closeDialog}>
        {step === "form" && (
          <CustodyOrderFormStep
            onCancel={() => setIsOpen(false)}
            onCustodyOrderCreated={(id) => {
              setCustodyOrderId(id);
            }}
          />
        )}
      </Dialog>
      {children}
    </CreateCustodyOrderDialogProviderContext.Provider>
  );
};

export const useCreateCustodyOrderDialog = () => {
  const ctx = useContext(CreateCustodyOrderDialogProviderContext);
  if (!ctx)
    throw new Error(
      "useCreateCustodyOrderDialog must be used inside CreateCustodyOrderDialogProvider",
    );
  return ctx;
};
